import { render, staticRenderFns } from "./IconList.vue?vue&type=template&id=40629aa0&scoped=true&"
import script from "./IconList.vue?vue&type=script&lang=js&"
export * from "./IconList.vue?vue&type=script&lang=js&"
import style0 from "./IconList.vue?vue&type=style&index=0&id=40629aa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40629aa0",
  null
  
)

export default component.exports